
/**
 * Stati associazione di una candidatura
 */
export const STATI_ASSOCIAZIONE = {
  ASSOCIATO: 1,
  RIFIUTATO_LAVORATORE: 2,
  RIFIUTATO_CITTADINO: 3,
  ANNULLATO: 4,
  DISPONIBILITA_RICHIEDERE: 5,
  DISPONIBILITA_OTTENUTA: 6,
};

/**
 * Al massimo 3 lavoratori si possono abbinare
 */
export const MAX_NUMERO_ASSOCIAZIONI = 3;
